import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { PlayerProvider, PlayerBar } from "@/components/Player";
import Home from "@/pages/Home";
import About from "@/pages/About";
import CreateBuild from "@/pages/CreateBuild";
import My5 from "@/pages/My5";
import Community from "@/pages/Community";
import Media from "@/pages/Media";
import GetInvolved from "@/pages/GetInvolved";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin, { AdminReset } from "@/pages/Admin";
import Gallery from "@/pages/Gallery";
import Discover from "@/pages/Discover";
import PanSchool from "@/pages/PanSchool";
import { Privacy, Terms, RefundPolicy } from "@/pages/Legal";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function Shell() {
    return (
        <div className="min-h-screen bg-obsidian text-slate-50 grain">
            <ScrollToTop />
            <Navbar />
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/create-build" element={<CreateBuild />} />
                    <Route path="/my-5" element={<My5 />} />
                    <Route path="/community" element={<Community />} />
                    <Route path="/media" element={<Media />} />
                    <Route path="/get-involved" element={<GetInvolved />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/discover" element={<Discover />} />
                    <Route path="/pan-school" element={<PanSchool />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/refund-policy" element={<RefundPolicy />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/admin/reset" element={<AdminReset />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <PlayerProvider>
                <Shell />
                <PlayerBar />
            </PlayerProvider>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#120E1C",
                        border: "1px solid rgba(168,85,247,0.4)",
                        color: "#F8FAFC",
                    },
                }}
            />
        </BrowserRouter>
    );
}
